import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import client from '../api/client';

export default function Parties() {
  const { admin } = useAdminAuth();
  const navigate = useNavigate();
  const [parties, setParties] = useState([]);
  const [form, setForm] = useState({ name: '', symbol: '', founding_year: '', username: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!admin) { navigate('/admin/login'); return; }
    loadParties();
  }, [admin, navigate]);

  const loadParties = () => {
    client.get('/parties').then(res => setParties(res.data)).catch(() => {});
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await client.post('/parties', form);
      setSuccess('Party added successfully');
      setForm({ name: '', symbol: '', founding_year: '', username: '', password: '' });
      loadParties();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add party');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this party?')) return;
    try {
      await client.delete(`/parties/${id}`);
      loadParties();
    } catch (err) {
      setError('Failed to delete party');
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Parties</h1>
        <Link to="/admin/dashboard" className="btn-secondary">Back</Link>
      </div>

      <div className="card">
        <h2>Add Party</h2>
        {error && <div className="error-msg">{error}</div>}
        {success && <div className="success-msg">{success}</div>}
        <form onSubmit={handleAdd}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="party-name">Name</label>
              <input id="party-name" name="name" type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div className="form-group">
              <label htmlFor="party-symbol">Symbol</label>
              <input id="party-symbol" name="symbol" type="text" value={form.symbol} onChange={e => setForm({ ...form, symbol: e.target.value })} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="party-founding_year">Founding Year</label>
              <input id="party-founding_year" name="founding_year" type="number" value={form.founding_year} onChange={e => setForm({ ...form, founding_year: e.target.value })} />
            </div>
            <div className="form-group">
              <label htmlFor="party-username">Username</label>
              <input id="party-username" name="username" type="text" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="party-password">Password</label>
            <input id="party-password" name="password" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
          </div>
          <button type="submit" className="btn-primary">Add Party</button>
        </form>
      </div>

      <div className="table-container">
        <h2>All Parties ({parties.length})</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Symbol</th>
              <th>Founded</th>
              <th>Username</th>
              <th>Votes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {parties.map(p => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>{p.symbol}</td>
                <td>{p.founding_year}</td>
                <td>{p.username}</td>
                <td>{p.vote_count}</td>
                <td>
                  <button onClick={() => handleDelete(p.id)} className="btn-danger">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
